import $ from 'jquery';
import Cookies from 'js-cookie';

$('[data-close-cookie]').on('click', function (e) {
    e.preventDefault();
    $('.cookie-consent').remove();
    Cookies.set('rwd_cookie_consent', true, { expires: 365 });
});
